import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withTracker } from 'components/Tracker';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { BasicMain, injectIntl } from 'components';
import immutableToJS from 'helpers/immutableToJS';
import { selectState } from 'redux/selectors';

const styles = theme => ({
  root: {
    width: '100%',
  },
  expansion: {
    width: '100%',
    flexWrap: 'wrap',
    marginLeft: '-15px !important',
    marginRight: '-15px !important',
  },
  heading: {
    fontSize: theme.typography.pxToRem(18),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
});

class Faqs extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    faqs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    formatMessage: PropTypes.func.isRequired,
  };

  state = { expanded: -1 };

  handleExpandChange = id => (e, expanded) => this.setState({ expanded: expanded ? id : -1 });

  render() {
    const { classes, faqs, formatMessage } = this.props;
    const { expanded } = this.state;

    return (
      <BasicMain>
        <h1>{formatMessage('FAQ')}</h1>
        {
          faqs.map(faq => (
            <ExpansionPanel
              expanded={expanded === faq.id}
              onChange={this.handleExpandChange(faq.id)}
              key={faq.id}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                classes={{
                  content: classes.expansion,
                }}
              >
                <Typography
                  className={`${classes.heading} ${expanded !== faq.id ? 'col-sm-4' : ''} col-12`}
                >
                  {faq.question}
                </Typography>
                {expanded !== faq.id && (
                  <Typography className={`${classes.secondaryHeading} col-sm-8 col-12`}>
                    {faq.answer}
                  </Typography>
                )}
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Typography style={{ whiteSpace: 'pre-line' }}>
                  {faq.answer}
                </Typography>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          ))
        }
      </BasicMain>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('options', 'faqs')(state),
});

export default compose(
  setDisplayName('Faqs'),
  connect(
    mapStateToProps,
  ),
  injectIntl,
  immutableToJS,
  withStyles(styles),
  withTracker,
)(Faqs);
